export default __webpack_public_path__ + "static/media/telegram_banner_dark.44f008e3.png";